import { render, staticRenderFns } from "./FunctionalityRaports.vue?vue&type=template&id=2c76bf2e&"
import script from "./FunctionalityRaports.vue?vue&type=script&lang=js&"
export * from "./FunctionalityRaports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports